export const REQUEST_UPDATE_SETTINGS: 'SETTINGS/REQUEST_UPDATE_SETTINGS' = 'SETTINGS/REQUEST_UPDATE_SETTINGS';
export const REQUEST_UPDATE_SETTINGS_SUCCESS: 'SETTINGS/REQUEST_UPDATE_SETTINGS_SUCCESS' =
	'SETTINGS/REQUEST_UPDATE_SETTINGS_SUCCESS';
export const REQUEST_UPDATE_SETTINGS_FAILURE: 'SETTINGS/REQUEST_UPDATE_SETTINGS_FAILURE' =
	'SETTINGS/REQUEST_UPDATE_SETTINGS_FAILURE';
